const STORAGE_KEY = 'clubdepot_wishlist';

function getWishlist() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function saveWishlist(handles) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles } }));
}

function isInWishlist(handle) {
  return getWishlist().includes(handle);
}

function toggleWishlist(handle) {
  const list = getWishlist();
  const index = list.indexOf(handle);
  if (index > -1) {
    list.splice(index, 1);
  } else {
    list.push(handle);
  }
  saveWishlist(list);
  return list.includes(handle);
}

function syncButtons(root) {
  const scope = root || document;
  const wishlist = getWishlist();
  scope.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const handle = button.getAttribute('data-wishlist-handle');
    const active = wishlist.includes(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
}

function updateCountBadges() {
  const count = getWishlist().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = String(count);
    el.classList.toggle('hidden', count === 0);
  });
}

function init() {
  syncButtons();
  updateCountBadges();

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.getAttribute('data-wishlist-handle');
    if (!handle) return;
    toggleWishlist(handle);
  });

  window.addEventListener('wishlist:change', () => {
    syncButtons();
    updateCountBadges();
  });

  // Product cards are re-rendered by facets/section morphing, so keep newly added
  // wishlist buttons in sync with localStorage without needing per-button listeners.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('[data-wishlist-toggle]')) {
          syncButtons(node.parentElement || document);
        } else if (node.querySelector?.('[data-wishlist-toggle]')) {
          syncButtons(node);
        }
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.ClubTradeWishlist = { getWishlist, toggleWishlist, isInWishlist };
